import { render, staticRenderFns } from "./RestaurantCategoryModal.vue?vue&type=template&id=23139d6c"
import script from "./RestaurantCategoryModal.vue?vue&type=script&lang=js"
export * from "./RestaurantCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports